import { GET_SUPPORT_ITEMS } from "constants/supportItems";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SUPPORT_ITEMS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
